{
  "//": [
    "The ThuisCoach mark, once. A roof line over a dumbbell — home plus training.",
    "",
    "Everything that draws the mark reads this file: Logo.tsx renders it live with",
    "design tokens, and scripts/generate-app-icons.mjs writes the favicon, the",
    "installed-app icons and the mark the mail carries. It exists because the mark",
    "used to be copied into each of those by hand, and design-system.md warned that",
    "'a change to the mark has to be made in both places'. That warning was not",
    "enough: favicon.svg had drifted to a different roof path, thicker strokes and a",
    "plate in #5a6bea — a blue from a palette this project no longer uses. Nobody",
    "noticed, because a favicon is 16 pixels wide.",
    "",
    "`plate` and `ink` are the baked colours for the static renders, which cannot",
    "read a CSS variable. check-icon-sources.mjs asserts they still equal",
    "--tc-teal-500 and --tc-stone-0 in tokens.css, so a palette change cannot leave",
    "the icons behind.",
    "",
    "`inkBox` is the measured extent of the two strokes — not the paths' geometry,",
    "which stops half a stroke width short on every side. Chrome's",
    "getBBox({stroke: true}) ignores the option and returns the fill box, so this",
    "was measured by rendering the strokes to a canvas at 50 px per unit and",
    "scanning for the first and last pixel with alpha: x 4.8 to 27.2, y 5.3 to 23.3.",
    "It is here because the mark is *not* vertically centred in its plate — the ink",
    "centre is y 14.3, not 16 — and a maskable icon has to be, since a launcher",
    "crops a circle around the canvas centre."
  ],
  "viewBox": "0 0 32 32",
  "plateRadius": 9,
  "roof": {
    "d": "M6 14.5 16 6.5l10 8",
    "strokeWidth": 2.4,
    "opacity": 0.55
  },
  "bar": {
    "d": "M10 22v-4M22 22v-4M10 20h12",
    "strokeWidth": 2.6
  },
  "static": {
    "plate": "#2f6f67",
    "ink": "#ffffff"
  },
  "inkBox": {
    "x": 4.8,
    "y": 5.3,
    "width": 22.4,
    "height": 18.0
  }
}
